"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createApi = require("../createApi");

var FederationsApi = function (_BaseApi) {
  (0, _inherits2["default"])(FederationsApi, _BaseApi);

  function FederationsApi() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, FederationsApi);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(FederationsApi)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getGroupCode", function (_ref) {
      var cardNumber = _ref.cardNumber,
          firstName = _ref.firstName,
          lastName = _ref.lastName,
          licence = _ref.licence,
          platformName = _ref.platformName,
          query = _ref.query;
      return _this.api.get("/".concat(platformName, "/usergroup"), {
        params: {
          cardNumber: cardNumber,
          firstName: firstName,
          lastName: lastName,
          licence: licence,
          query: query
        },
        fullResponse: true
      });
    });
    return _this;
  }

  return FederationsApi;
}(_createApi.BaseApi);

var _default = FederationsApi;
exports["default"] = _default;
//# sourceMappingURL=federations.js.map